import {PredictionParametersDict} from 'machine-learning/parameter-optimization/prediction/PredictionParametersTypes';
import * as TaskRunner from 'util/TaskRunner';
import {JSONValue} from 'util/Types';

interface TableConfig {
  name: string;
  query: string;
  selectedColumnNames: Array<string>;
}

interface RelationshipConfig {
  parentTableName: string;
  parentColumnName: string;
  childTableName: string;
  childColumnName: string;
}

interface FilterConfig {
  tableName: string;
  columnName: string;
  operator: string;
  value: JSONValue;
}

interface ColumnConfig {
  tableName: string;
  columnName: string;
}

export interface TrainParameterOptimizationRequestData {
  tables: Array<TableConfig>;
  relationships: Array<RelationshipConfig>;
  filters: Array<FilterConfig>;
  label: ColumnConfig;
  grouping: ColumnConfig;
  baseTableName: string;
  stepId: string;
}

export interface ParameterOptimizationPredictionRequestData {
  features: PredictionParametersDict;
  stepId: string;
}

export interface ParameterOptimizationPredictionResponse {
  point: PredictionParametersDict;
  value: number;
  lowerBound: number;
  upperBound: number;
  intervalWidth: number;
  uncertainty: number;
}

export function trainParameterOptimization(data: TrainParameterOptimizationRequestData): Promise<void> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/machine-learning/parameter-optimization',
    data,
  });
}

export function runParameterOptimizationPrediction(
  data: ParameterOptimizationPredictionRequestData
): Promise<ParameterOptimizationPredictionResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/machine-learning/parameter-optimization:predict',
    data,
  });
}
